import { Banknote, FileText, CreditCard, Smartphone, Building2, Repeat, Wallet, Heart, Globe, Gift, Clock, Link, Tag, type LucideIcon } from "lucide-react";

export const PAYMENT_ICON_MAP: Record<string, LucideIcon> = {
  Banknote, FileText, CreditCard, Smartphone, Building2, Repeat,
  Wallet, Heart, Globe, Gift, Clock, Link, Tag,
};

export function getPaymentIcon(iconName: string | null | undefined): LucideIcon | null {
  if (!iconName) return null;
  return PAYMENT_ICON_MAP[iconName] ?? null;
}
